import type { ModeDefinition, WeldParameterInputs } from "./types";

export const defaultInputs: WeldParameterInputs = {
  aMass: 5,
  wireDiameter: 1.2,
  wireFeed: 23,
  travelSpeed: 42
};

export const modes: ModeDefinition[] = [
  {
    mode: "aMass",
    label: "aMass",
    shortLabel: "a-Maß",
    unit: "mm",
    description: "aMass"
  },
  {
    mode: "travelSpeed",
    label: "travelSpeed",
    shortLabel: "vs",
    unit: "cm/min",
    description: "travelSpeed"
  },
  {
    mode: "wireFeed",
    label: "wireFeed",
    shortLabel: "vD",
    unit: "m/min",
    description: "wireFeed"
  },
  {
    mode: "wireDiameter",
    label: "wireDiameter",
    shortLabel: "Draht-Ø",
    unit: "mm",
    description: "wireDiameter"
  }
];
